import { gql } from 'graphql.macro';

// DD-3484 Marketplace: the parent order's communication, shown read-only in the
// subcontract flow. Each is an existing guarded query: `comments` and `chatMessages`
// require a party to the order, `messages` (the lab chat) and `internalOrderDetails`
// (internal notes) are scoped to the caller's own lab — the sending lab is the parent's
// supplier, so it reads exactly what it already sees on the order.
export const subcontractCommunicationTemplate = gql`
    query subcontractCommunication($orderId: MongoDbObjectId!) {
        comments(orderId: $orderId) {
            message
            date
            user {
                fullName
            }
            version
        }
        chatMessages(orderId: $orderId) {
            _id
            senderName
            message
            createdAt
        }
        messages(orderId: $orderId) {
            _id
            originatorName {
                firstName
                lastName
            }
            createdAt
            message
        }
        internalOrderDetails(orderId: $orderId) {
            _id
            notes
            externalNotes
        }
    }
`;

// DD-3485 Marketplace: this lab's defaults for one supplier. Resolves only for the
// lab that owns the connection (the row's customer).
export const subcontractDefaultsTemplate = gql`
    query subcontractDefaults($supplierId: MongoDbObjectId!) {
        supplier(supplierId: $supplierId) {
            _id
            subcontractDefaults {
                includePatientReference
                includePatientIdentityNumber
                includeDentistName
                includeAllRestorations
                includeAttachments
                includeScanCaseFiles
                messageFields
                messageLanguage
                responsibleUserIds
            }
        }
    }
`;

export const updateSubcontractDefaultsTemplate = gql`
    mutation updateSubcontractDefaults($supplierId: MongoDbObjectId!, $defaults: SubcontractDefaultsInput!) {
        updateSubcontractDefaults(supplierId: $supplierId, defaults: $defaults) {
            _id
            subcontractDefaults {
                includePatientReference
                includePatientIdentityNumber
                includeDentistName
                includeAllRestorations
                includeAttachments
                includeScanCaseFiles
                messageFields
                messageLanguage
                responsibleUserIds
            }
        }
    }
`;

// DD-3689: the lab's message to its subcontractor, translated into the partner's language.
// orderId is the parent order; only its supplier may ask.
export const translateSubcontractMessageTemplate = gql`
    query translateSubcontractMessage($orderId: MongoDbObjectId!, $text: String!, $language: LocaleLanguage!) {
        translateSubcontractMessage(orderId: $orderId, text: $text, language: $language)
    }
`;
